import { IconLoader2 } from '@tabler/icons-react';
import { classnames } from '@/libs/utils';

const OriginalRecordingGenerationInProgress = ({ showLoaderOnPage }: { showLoaderOnPage: boolean }) => {
  return (
    <div
      className={classnames(
        'flex size-full flex-col items-center justify-center bg-[#EAECF2]',
        showLoaderOnPage ? 'fixed inset-0' : ''
      )}
    >
      <IconLoader2 color="#63748A" className="animate-spin" size={24} />
      <div className="mt-2 flex flex-col items-center justify-center text-[#63748A]">
        <div className="font-medium">Migration in progress</div>
        <div className="mt-2 flex flex-col text-center text-sm">
          This will take around 10 minutes per one hour of video.
          <br />
          The migration will continue in the background.
          <br />
          Please revisit this page to check the status.
        </div>
      </div>
    </div>
  );
};

export default OriginalRecordingGenerationInProgress;
